import { Injectable, signal, effect } from '@angular/core';

export type Theme = 'light' | 'dark';

@Injectable({ providedIn: 'root' })
export class ThemeService {
  private readonly STORAGE_KEY = 'inv-theme';

  /** Reactive signal holding the current theme */
  theme = signal<Theme>(this.getStoredTheme());

  constructor() {
    // Apply immediately so there's no flash on load
    document.documentElement.setAttribute('data-theme', this.theme());

    // Keep DOM attribute and localStorage in sync whenever signal changes
    effect(() => {
      const t = this.theme();
      document.documentElement.setAttribute('data-theme', t);
      try { localStorage.setItem(this.STORAGE_KEY, t); } catch { /* private/incognito */ }
    });
  }

  /** Toggle between light and dark */
  toggle() {
    this.theme.update(t => (t === 'light' ? 'dark' : 'light'));
  }

  /** Returns true when dark mode is active */
  isDark() {
    return this.theme() === 'dark';
  }

  private getStoredTheme(): Theme {
    try {
      return localStorage.getItem(this.STORAGE_KEY) === 'dark' ? 'dark' : 'light';
    } catch {
      return 'light';
    }
  }
}
